function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { trackEvent } from "services/bigbrain-service";
import { HOVERABLE_CARD_HOVERED } from "constants/bigbrain-event-types";
import HoverableCard from "./hoverable-card/hoverable-card";
import { StyledHoverableCardsGridComponent } from "./hoverable-cards-grid-component.scss";
const HoverableCardsGridComponent = ({ cards, defaultHoveredCard, defaultColor, fullParagraphAdvancedConfig, textResizeConfig })=>{
    const [contentMaxHeight, setContentMaxHeight] = useState(null);
    const [selectedCardIndex, setSelectedCardIndex] = useState(defaultHoveredCard - 1 < cards.length ? defaultHoveredCard - 1 : 0);
    const setCardMaxHeight = useCallback((height)=>{
        setContentMaxHeight((maxHeight)=>Math.max(height, maxHeight !== null && maxHeight !== void 0 ? maxHeight : 0));
    }, []);
    const restartMaxHeight = useCallback(()=>setContentMaxHeight(null), []);
    const onCardHover = (index)=>{
        setSelectedCardIndex(index);
        trackEvent(HOVERABLE_CARD_HOVERED, {
            info1: index
        });
    };
    useEffect(()=>{
        window.addEventListener("resize", restartMaxHeight);
        return ()=>window.removeEventListener("resize", restartMaxHeight);
    }, [
        restartMaxHeight
    ]);
    return /*#__PURE__*/ _jsx(StyledHoverableCardsGridComponent, {
        className: "hoverable-cards-grid-component",
        style: {
            height: `${contentMaxHeight}px`
        },
        children: cards === null || cards === void 0 ? void 0 : cards.map((card, index)=>/*#__PURE__*/ _jsx(HoverableCard, _object_spread({
                textResizeConfig: textResizeConfig,
                setCardsMaxHeight: setCardMaxHeight,
                fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
                defaultColor: defaultColor,
                isSelected: index === selectedCardIndex,
                onHover: ()=>onCardHover(index)
            }, card), index))
    });
};
export default HoverableCardsGridComponent;
